<template>
  <div @click="onClose" class="wrapper">
    <div :class="{wrapper_body: true, open: modalData.open}">
      <div class="row" id="sideBarModalComponent">
        <button @click="() => onClose(null, true)" class="btn btn-default closeBtn">
          <i class="icon-fa icon-fa-remove"/></button>
        <div class="col-md-3 hide_modal">
          <div v-if="extraInfo" class="extra_info card">
            <div class="card-header">
              <h6>{{ extraInfo.title }}</h6>
            </div>
            <div class="card-body order_notification_block">
              <div v-html='extraInfo.body'/>
            </div>
          </div>
        </div>
        <div class="col-md-9 m-0 p-0">
          <div class="editBlock p-2">
            <div class="loading_div" v-if="loading">
              <pulse-loader :loading="loading" :color="color" class="text-center"/>
            </div>
            <edit
              :orderId="modalData.orderId"
              :disableLoading="disableLoading"
              :closeOrder="onClose"
              :isModal="true"
              :fetchOrders="fetchOrders"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
// import edit from "../../../views/orders/edit";
import edit from '@/views/orders/Edit2'

export default {
  components: {
    edit
  },
  props: ['modalData', 'onModalClose', 'fetchOrders'],
  computed: {
    orderToEdit() {
      return this.$store.getters['orders/orderToEdit']
    },
    $callBackActions() {
      return this.$store.getters['platform/callBackActions']
    },
  },
  data() {
    return {
      color: '#5BBFDE',
      loading: true,
      extraInfo: null,
    }
  },
  mounted() {
    const body = document.getElementsByTagName('body')[0]
    body.style.overflow = 'hidden'
    this.showExtraInfo()
  },
  beforeDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = "auto";
  },
  methods: {
    showExtraInfo() {
      if (this.orderToEdit.dialog && this.orderToEdit.dialog.messages) {
        console.log(this.orderToEdit.dialog);
        this.extraInfo = {
          title: 'Запрос',
          // body: this.orderToEdit.dialog && this.orderToEdit.dialog.messages && (this.orderToEdit.dialog.messages[0].data.extra || this.orderToEdit.dialog.messages[0].data.message)
          body: this.orderToEdit.dialog.messages.reduce((acc, m) => {
            acc += `<p>${m.message}</p>`;
            return acc;
          }, '')
        }
      }
    },
    disableLoading() {
      this.loading = false
    },
    onClose(e, global = false) {
      if (global || e && e.target && e.target.id === 'sideBarModalComponent' || e && e.target && e.target.className && typeof e.target.className === 'string' && e.target.className.includes('hide_modal')) {
        // if (e.target.id === 'sideBarModalComponent') {
        const body = document.getElementsByTagName('body')[0]
        body.style.overflow = 'auto'
        this.$store.dispatch('orders/setOrderToEdit', {})
        if (this.modalData.callBackAction) {
          if (this.modalData.callBackAction === 'resetOrder') {
            this.$store.dispatch('orders/setEditNewOrder', {extra_options: {}});
          }
          this.$store.dispatch('platform/setCallBackActions', {action: this.modalData.callBackAction})
        }
        this.onModalClose()
      }
    }
  }
}

</script>

<style>
.order_notification_block p {
  background-color: #ededed;
  padding: 2px 7px;
  margin-bottom: 3px;
  border-radius: 3px;
}
</style>

<style scoped>
.extra_info {
  position: fixed;
  width: calc(25% - 10px);
  margin: 5px;
}

.editBlock .main-content {
  padding: 0;
}

.loading_div {
  position: absolute;
  top: 50%;
  left: 50%;
}

.editBlock {
  background-color: white;
  min-height: 100vh;
}

.wrapper_body.open {
  /*left: calc(100% - 300px);*/
  /*left: 25%;*/
  transition: all 0.3s ease 0s;
}

.wrapper_body {
  position: relative;
  transition: all 0.3s ease 0s;
  width: 100%;
  /*left: 100%;*/
  min-height: 100%;
  z-index: 9999;
  background-color: transparent;
}

.wrapper {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 200;
  transition: all 0.3s ease 0s;
  background-color: rgba(0, 0, 0, 0.5);
}

.closeBtn {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 9;
}
</style>
